/**
 * Shatkona contact form spam guard — honeypot + time-trap.
 *
 * Shopify's native contact form doesn't give theme code a way to run custom
 * validation on Shopify's own servers before a submission is accepted, so
 * this works entirely in the browser: if either check fails, the form
 * submission is cancelled before it's ever sent to Shopify.
 *
 * 1) Honeypot: a field real visitors never see (hidden via CSS, not
 *    display:none — some bots skip display:none fields, so this uses an
 *    off-screen technique instead). Bots that blindly fill every input on
 *    the page fill it in; if it has a value on submit, it's spam.
 * 2) Time-trap: records when the form became visible on page load. A
 *    submission that arrives faster than a human could realistically read
 *    and fill the form is almost certainly a bot.
 *
 * Not a guarantee against a sophisticated bot running a full browser that
 * waits and skips hidden fields deliberately — but stops the vast majority
 * of real-world automated form spam, which is unsophisticated.
 */
(function () {
  var MIN_SECONDS_TO_SUBMIT = 3;

  function setup() {
    var form = document.getElementById('ContactForm');
    if (!form) return;

    var loadedAtField = document.getElementById('ContactForm-loaded-at');
    var honeypotField = document.getElementById('ContactForm-website');
    if (loadedAtField) {
      loadedAtField.value = Date.now();
    }

    form.addEventListener('submit', function (event) {
      if (honeypotField && honeypotField.value.trim() !== '') {
        // Honeypot filled in — almost certainly a bot. Silently block.
        event.preventDefault();
        return;
      }

      if (loadedAtField && loadedAtField.value) {
        var loadedAt = parseInt(loadedAtField.value, 10);
        var elapsedSeconds = (Date.now() - loadedAt) / 1000;
        if (elapsedSeconds < MIN_SECONDS_TO_SUBMIT) {
          event.preventDefault();
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();